module.exports = __webpack_public_path__ + "img/output-13.5a7fa142.png";